module.exports = __webpack_public_path__ + "img/miine.53b1d7ae.svg";